import { useContext } from "react"
import { ICordovaContext } from "../cordovaTypes"
import { CordovaContext } from "../cordovaLib"

export function useCordova(): ICordovaContext {
    return useContext(CordovaContext)
}
